import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  modal: {
    alignSelf: "center",
    backgroundColor: "$survey_card",
    width: "30vmax",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  closeButton: {
    alignSelf: "center",
    backgroundColor: "$question_text",
    width: "30vmax",
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  closeButtonText: {
    paddingVertical: "1vh",
    alignSelf: "center",
    color: "$survey_card",
    fontSize: "$option_text_size",
    fontFamily: "$option_text_style",
  },
});
